// React import removed as it's not needed with new JSX transform
import {useAuth} from '../hooks/useAuth';
import {AuthorizationService} from '../../../Services/authorization/AuthorizationService';
import Button from '../../../Presentation/components/ui/Button';

const UnauthorizedScreen = () => {
  const {user, logout} = useAuth();
  const authorizationService = AuthorizationService.getInstance();
  const {title, message, isMarketer} = authorizationService.getUnauthorizedMessage(user);

  const handleLogout = async () => {
    await logout();
    window.location.href = '/login';
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <div className="mb-6">
          <div className="text-6xl mb-4">🚫</div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            {title}
          </h1>

          <div className="text-gray-600">
            <p className="mb-4">{message}</p>
            {isMarketer && (
              <p className="text-sm text-gray-500">
                يرجى استخدام تطبيق المطورين المخصص لك.
              </p>
            )}
          </div>
        </div>

        <div className="space-y-3">
          <Button
            onClick={handleLogout}
            variant="primary"
            className="w-full"
          >
            تسجيل الخروج
          </Button>

          {isMarketer && (
            <div className="text-sm text-gray-500">
              أو قم بتسجيل الدخول بحساب إداري
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedScreen;
